// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-BookingDetails-styles___bookingDetails--RbsgY {
  text-align: left;
  padding: 32px;
  max-width: 736px;
  display: grid;
}

  .components-BookingDetails-styles___bookingDetails--RbsgY.components-BookingDetails-styles___widerNotes--rfGA9 {
    max-width: 900px;
  }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___header--nZl6V {
    display: flex;
  }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___header--nZl6V .components-BookingDetails-styles___title--Is77J {
      flex: 1;
      font-size: 21px;
      line-height: 24px;
      font-weight: 500;
    }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___header--nZl6V .components-BookingDetails-styles___title--Is77J span {
        font-size: 15px;
        color: #6d717a;
        font-weight: 400;
      }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___header--nZl6V .components-BookingDetails-styles___tripAdvisor--kZW0v {
      text-align: right;
    }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___header--nZl6V .components-BookingDetails-styles___tripAdvisor--kZW0v img {
        width: 95px;
        height: auto;
      }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___header--nZl6V .components-BookingDetails-styles___avatarAndName--ln44N {
      display: flex;
      width: 100%;
    }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___header--nZl6V .components-BookingDetails-styles___avatarAndName--ln44N .components-BookingDetails-styles___avatarContainer--Xz_fy {
        margin-right: 24px;
        margin-top: 11px;
      }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___header--nZl6V .components-BookingDetails-styles___avatarAndName--ln44N .components-BookingDetails-styles___avatarContainer--Xz_fy .components-BookingDetails-styles___avatar--CfylO {
          width: 32px;
          height: 32px;
        }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___header--nZl6V .components-BookingDetails-styles___avatarAndName--ln44N .components-BookingDetails-styles___avatarContainer--Xz_fy .components-BookingDetails-styles___avatarLetter--Dc7iZ {
          width: 50px;
          height: 50px;
          font-size: 15px;
          color: #6d717a;
          letter-spacing: 0;
          text-align: center;
          background-color: #e0e2e6;
          text-transform: uppercase;
        }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___header--nZl6V .components-BookingDetails-styles___avatarAndName--ln44N .components-BookingDetails-styles___headerInfoContainer--q6fEg {
        display: flex;
        flex-grow: 1;
        justify-content: space-between;
        width: 100%;
      }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___header--nZl6V .components-BookingDetails-styles___avatarAndName--ln44N .components-BookingDetails-styles___travelerInformationFlightTitle--wJpqm {
        font-size: 17px;
        color: #1b2432;
        letter-spacing: 0;
        font-weight: 500;
        margin: 4px 0;
      }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___header--nZl6V .components-BookingDetails-styles___avatarAndName--ln44N .components-BookingDetails-styles___travelerInformationFlightSubtitle--eybDb {
        font-size: 13px;
        font-weight: 300;
      }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___header--nZl6V .components-BookingDetails-styles___avatarAndName--ln44N .components-BookingDetails-styles___travelerInformationFlightSubtitle--eybDb .components-BookingDetails-styles___travelerNumber--IhaYo {
          font-weight: 500;
        }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___header--nZl6V .components-BookingDetails-styles___avatarAndName--ln44N .components-BookingDetails-styles___travelerInformationHotelTitle--oQq4a {
        font-size: 13px;
        color: #1b2432;
        letter-spacing: 0;
        font-weight: 300;
        margin: 4px 0;
      }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___header--nZl6V .components-BookingDetails-styles___avatarAndName--ln44N .components-BookingDetails-styles___travelerInformationHotelSubtitle--Aat9x {
        font-size: 17px;
        font-weight: 500;
      }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___header--nZl6V .components-BookingDetails-styles___passengerInfo--yMs2E {
      display: flex;
      align-content: space-between;
      justify-content: space-between;
      max-width: 672px;
    }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___header--nZl6V .components-BookingDetails-styles___passengerInfoRow--tZfrE {
    }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___PassengerHeader--moKWG {
    padding: 32px 0;
    border-bottom: 1px solid #c6c8cc;
  }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___PassengerHeader--moKWG:last-child {
      padding: 32px 0 0;
      border-bottom: none;
    }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___PassengerHeader--moKWG .components-BookingDetails-styles___title--Is77J {
      margin-bottom: 24px;
      font-size: 17px;
      color: #1b2432;
      letter-spacing: 0;
      font-weight: 500;
    }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___PassengerHeader--moKWG .components-BookingDetails-styles___travelerName--xg6xE {
      font-size: 15px;
      color: #1b2432;
      letter-spacing: 0;
      font-weight: 500;
      font-family: 'Roboto';
    }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___PassengerHeader--moKWG .components-BookingDetails-styles___passengerInfo--yMs2E {
      max-width: 672px;
      border: 1px solid #dddee0;
      padding: 23px;
      border-radius: 4px;
    }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___PassengerHeader--moKWG .components-BookingDetails-styles___Info--N994y {
      display: flex;
    }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___PassengerHeader--moKWG .components-BookingDetails-styles___passengerInfoRow--tZfrE {
      min-width: 270px;
      font-size: 13px;
      color: #6d717a;
      letter-spacing: 0;
      line-height: 20px;
    }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___PassengerHeader--moKWG .components-BookingDetails-styles___passengerInfoRow--tZfrE .components-BookingDetails-styles___passportInfo--0xkSK {
        display: flex;
      }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___PassengerHeader--moKWG .components-BookingDetails-styles___passengerInfoRow--tZfrE .components-BookingDetails-styles___passportInfo--0xkSK p {
          margin-top: 0px;
        }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___PassengerHeader--moKWG .components-BookingDetails-styles___passengerInfoRow--tZfrE .components-BookingDetails-styles___passportInfo--0xkSK .components-BookingDetails-styles___passList--ZH0Sg {
          line-height: 7px;
          margin-top: 6px;
          margin-left: 5px;
          color: #1b2432;
        }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___PassengerHeader--moKWG .components-BookingDetails-styles___passengerInfoRow--tZfrE span {
        color: #1b2432;
        letter-spacing: 0;
      }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___PassengerHeader--moKWG .components-BookingDetails-styles___passengerInfoRow--tZfrE .components-BookingDetails-styles___label--pNQDp {
        font-size: 13px;
        color: #6d717a;
        letter-spacing: 0;
        line-height: 20px;
      }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___additionalFlightDetails--Mbbjo {
    padding-top: 8px;
    border-bottom: none;
  }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___additionalFlightDetails--Mbbjo .components-BookingDetails-styles___infoContainer--xn9tq {
      max-width: 672px;
      border: 1px solid #dddee0;
      padding: 23px;
      border-radius: 4px;
    }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___additionalFlightDetails--Mbbjo .components-BookingDetails-styles___Info--N994y {
      display: flex;
    }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___additionalFlightDetails--Mbbjo .components-BookingDetails-styles___additionalInfoRow--jIz2j {
      min-width: 270px;
      font-size: 13px;
      color: #6d717a;
      letter-spacing: 0;
      line-height: 20px;
    }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___additionalFlightDetails--Mbbjo .components-BookingDetails-styles___additionalInfoRow--jIz2j span {
        color: #1b2432;
        letter-spacing: 0;
      }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___checkins--SzxUD {
    display: flex;
  }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___checkins--SzxUD .components-BookingDetails-styles___checkin--KHlVG {
      padding-right: 40px;
    }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___roomType--LQp7f,
  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___checkins--SzxUD {
    font-weight: 500;
    font-size: 15px;
    padding: 24px 0;
    border-bottom: 1px solid #c6c8cc;
  }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___roomType--LQp7f span, .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___checkins--SzxUD span {
      color: #6d717a;
      font-size: 13px;
      line-height: 20px;
      font-weight: 400;
    }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___info--vdYXv {
    display: flex;
    padding: 24px 0 0;
  }

  .components-BookingDetails-styles___bookingDetails--RbsgY .components-BookingDetails-styles___info--vdYXv .components-BookingDetails-styles___text--VIEPH {
      padding: 0 24px 0 6px;
      color: #6d717a;
      font-size: 15px;
    }

.components-BookingDetails-styles___boldText--oaTpP {
  font-family: 'Roboto';
  font-size: 17px;
  color: #1b2432;
  letter-spacing: 0;
}

.components-BookingDetails-styles___lightSubtitle--F67oL {
  font-family: 'Roboto';
  font-size: 13px;
  color: #6d717a;
  letter-spacing: 0;
}

.components-BookingDetails-styles___editButton--S_Ryu {
  min-height: 32px;
  width: 55px;
  border-radius: 4px;
  color: #4f84fa;
  text-align: center;
  align-self: center;
  border: 1px solid #3189fb;
  display: flex;
  font-size: 15px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  justify-self: right;
}

.components-BookingDetails-styles___linkText--GEco_ {
  color: #1e8aff !important;
  font-size: 13px;
  cursor: pointer;
}

.components-BookingDetails-styles___linkText--GEco_:hover {
    color: blue !important;
    text-decoration: underline;
  }

.components-BookingDetails-styles___tag--VRc7e {
  background: rgba(255, 255, 255, 0);
  border: 1px solid #1b2432;
  border-radius: 4px;
  font-size: 13px;
  color: #1b2432;
  letter-spacing: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 32px;
  width: -moz-fit-content;
  width: fit-content;
  padding-left: 6px;
  padding-right: 6px;
  margin-left: 7px;
}

.components-BookingDetails-styles___tagsContainer--OQuYM {
  display: flex;
  align-items: center;
}

.components-BookingDetails-styles___customFieldsList--FDhiv {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
}

.components-BookingDetails-styles___customFieldRow--T3KLC {
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-size: 13px;
  color: #1b2432;
}

.components-BookingDetails-styles___customFieldName--XN4ZO {
  font-weight: 500;
  color: #6d717a;
  white-space: nowrap;
  min-width: 120px;
}

.components-BookingDetails-styles___customFieldValue--eSaww {
  color: #1b2432;
  word-break: break-word;
}

.components-BookingDetails-styles___customFieldEmpty--D7ftn {
  font-size: 13px;
  color: #9ea3ad;
  font-style: italic;
}

.components-BookingDetails-styles___additionalBookingContainer--yoN3v {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.components-BookingDetails-styles___additionalBookingContainer--yoN3v div:first-child {
    font-size: 13px;
    color: #6d717a;
    letter-spacing: 0;
    line-height: 20px;
    width: 100%;
    overflow-wrap: break-word;
  }

.components-BookingDetails-styles___additionalBookingContainer--yoN3v .components-BookingDetails-styles___textarea--wMVdN {
    width: 100%;
    font-family: 'Roboto', sans-serif;
    font-size: 13px;
    resize: none;
    height: 100px;
    line-height: 20px;
    border: 1px solid #dddee0;
    border-radius: 4px;
    padding: 8px;
    margin-bottom: 13px;
  }

.components-BookingDetails-styles___additionalBookingContainer--yoN3v .components-BookingDetails-styles___noteText--ZZzIH {
    font-family: 'Roboto', sans-serif;
    font-size: 13px;
    width: 100%;
    height: 100px;
    overflow: scroll;
    border: 1px solid #dddee0;
    border-radius: 4px;
    padding: 8px;
    margin-top: 0px;
  }

.components-BookingDetails-styles___additionalDetailsTitle--nXVXq {
  font-size: 17px;
  color: #1b2432;
  letter-spacing: 0;
  margin-top: 0;
  margin-bottom: 14px;
}

.components-BookingDetails-styles___bookingAdditionalDetails--cRzy3 {
  margin-top: 32px;
  margin-bottom: 32px;
}

.components-BookingDetails-styles___fraudSubtitle--_6xyS {
  font-size: 13px;
  color: #6d717a;
  margin-bottom: 5px;
}
`, "",{"version":3,"sources":["webpack://./components/BookingDetails/styles.pcss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,aAAa;AA6Of;;EA3OE;IACE,gBAAgB;EAClB;;EACA;IACE,aAAa;EA+Ff;;EA7FE;MACE,OAAO;MACP,eAAe;MACf,iBAAiB;MACjB,gBAAgB;IAOlB;;EALE;QACE,eAAe;QACf,cAAc;QACd,gBAAgB;MAClB;;EAGF;MACE,iBAAiB;IAMnB;;EAJE;QACE,WAAW;QACX,YAAY;MACd;;EAGF;MACE,aAAa;MACb,WAAW;IA0Db;;EAzDE;QACE,kBAAkB;QAClB,gBAAgB;MAiBlB;;EAfE;UACE,WAAW;UACX,YAAY;QACd;;EAEA;UACE,WAAW;UACX,YAAY;UACZ,eAAe;UACf,cAAc;UACd,iBAAiB;UACjB,kBAAkB;UAClB,yBAAyB;UACzB,yBAAyB;QAC3B;;EAGF;QACE,aAAa;QACb,YAAY;QACZ,8BAA8B;QAC9B,WAAW;MACb;;EAEA;QACE,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,gBAAgB;QAChB,aAAa;MACf;;EAEA;QACE,eAAe;QACf,gBAAgB;MAKlB;;EAHE;UACE,gBAAgB;QAClB;;EAGF;QACE,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,gBAAgB;QAChB,aAAa;MACf;;EAEA;QACE,eAAe;QACf,gBAAgB;MAClB;;EAGF;MACE,aAAa;MACb,4BAA4B;MAC5B,8BAA8B;MAC9B,gBAAgB;IAClB;;EAEA;IACA;;EAGF;IACE,eAAe;IACf,gCAAgC;EAoElC;;EAlEE;MACE,iBAAiB;MACjB,mBAAmB;IACrB;;EAEA;MACE,mBAAmB;MACnB,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,gBAAgB;IAClB;;EAEA;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,gBAAgB;MAChB,qBAAqB;IACvB;;EAEA;MACE,gBAAgB;MAChB,yBAAyB;MACzB,aAAa;MACb,kBAAkB;IACpB;;EAEA;MACE,aAAa;IACf;;EAEA;MACE,gBAAgB;MAChB,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,iBAAiB;IA4BnB;;EA1BE;QACE,aAAa;MAYf;;EAVE;UACE,eAAe;QACjB;;EAEA;UACE,gBAAgB;UAChB,eAAe;UACf,gBAAgB;UAChB,cAAc;QAChB;;EAGF;QACE,cAAc;QACd,iBAAiB;MACnB;;EAEA;QACE,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,iBAAiB;MACnB;;EAIJ;IACE,gBAAgB;IAChB,mBAAmB;EAyBrB;;EAvBE;MACE,gBAAgB;MAChB,yBAAyB;MACzB,aAAa;MACb,kBAAkB;IACpB;;EAEA;MACE,aAAa;IACf;;EAEA;MACE,gBAAgB;MAChB,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,iBAAiB;IAMnB;;EAJE;QACE,cAAc;QACd,iBAAiB;MACnB;;EAIJ;IACE,aAAa;EAKf;;EAHE;MACE,mBAAmB;IACrB;;EAGF;;IAEE,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,gCAAgC;EAQlC;;EANE;MACE,cAAc;MACd,eAAe;MACf,iBAAiB;MACjB,gBAAgB;IAClB;;EAGF;IACE,aAAa;IACb,iBAAiB;EAOnB;;EALE;MACE,qBAAqB;MACrB,cAAc;MACd,eAAe;IACjB;;AAIJ;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,eAAe;AAKjB;;AAJE;IACE,sBAAsB;IACtB,0BAA0B;EAC5B;;AAGF;EACE,kCAAkC;EAClC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAmChC;;AAjCE;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,yBAAyB;EAC3B;;AAEA;IACE,WAAW;IACX,iCAAiC;IACjC,eAAe;IACf,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;EACrB;;AAEA;IACE,iCAAiC;IACjC,eAAe;IACf,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,eAAe;EACjB;;AAGF;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".bookingDetails {\n  text-align: left;\n  padding: 32px;\n  max-width: 736px;\n  display: grid;\n\n  &.widerNotes {\n    max-width: 900px;\n  }\n  .header {\n    display: flex;\n\n    .title {\n      flex: 1;\n      font-size: 21px;\n      line-height: 24px;\n      font-weight: 500;\n\n      span {\n        font-size: 15px;\n        color: #6d717a;\n        font-weight: 400;\n      }\n    }\n\n    .tripAdvisor {\n      text-align: right;\n\n      img {\n        width: 95px;\n        height: auto;\n      }\n    }\n\n    .avatarAndName {\n      display: flex;\n      width: 100%;\n      .avatarContainer {\n        margin-right: 24px;\n        margin-top: 11px;\n\n        .avatar {\n          width: 32px;\n          height: 32px;\n        }\n\n        .avatarLetter {\n          width: 50px;\n          height: 50px;\n          font-size: 15px;\n          color: #6d717a;\n          letter-spacing: 0;\n          text-align: center;\n          background-color: #e0e2e6;\n          text-transform: uppercase;\n        }\n      }\n\n      .headerInfoContainer {\n        display: flex;\n        flex-grow: 1;\n        justify-content: space-between;\n        width: 100%;\n      }\n\n      .travelerInformationFlightTitle {\n        font-size: 17px;\n        color: #1b2432;\n        letter-spacing: 0;\n        font-weight: 500;\n        margin: 4px 0;\n      }\n\n      .travelerInformationFlightSubtitle {\n        font-size: 13px;\n        font-weight: 300;\n\n        .travelerNumber {\n          font-weight: 500;\n        }\n      }\n\n      .travelerInformationHotelTitle {\n        font-size: 13px;\n        color: #1b2432;\n        letter-spacing: 0;\n        font-weight: 300;\n        margin: 4px 0;\n      }\n\n      .travelerInformationHotelSubtitle {\n        font-size: 17px;\n        font-weight: 500;\n      }\n    }\n\n    .passengerInfo {\n      display: flex;\n      align-content: space-between;\n      justify-content: space-between;\n      max-width: 672px;\n    }\n\n    .passengerInfoRow {\n    }\n  }\n\n  .PassengerHeader {\n    padding: 32px 0;\n    border-bottom: 1px solid #c6c8cc;\n\n    &:last-child {\n      padding: 32px 0 0;\n      border-bottom: none;\n    }\n\n    .title {\n      margin-bottom: 24px;\n      font-size: 17px;\n      color: #1b2432;\n      letter-spacing: 0;\n      font-weight: 500;\n    }\n\n    .travelerName {\n      font-size: 15px;\n      color: #1b2432;\n      letter-spacing: 0;\n      font-weight: 500;\n      font-family: 'Roboto';\n    }\n\n    .passengerInfo {\n      max-width: 672px;\n      border: 1px solid #dddee0;\n      padding: 23px;\n      border-radius: 4px;\n    }\n\n    .Info {\n      display: flex;\n    }\n\n    .passengerInfoRow {\n      min-width: 270px;\n      font-size: 13px;\n      color: #6d717a;\n      letter-spacing: 0;\n      line-height: 20px;\n\n      .passportInfo {\n        display: flex;\n\n        p {\n          margin-top: 0px;\n        }\n\n        .passList {\n          line-height: 7px;\n          margin-top: 6px;\n          margin-left: 5px;\n          color: #1b2432;\n        }\n      }\n\n      span {\n        color: #1b2432;\n        letter-spacing: 0;\n      }\n\n      .label {\n        font-size: 13px;\n        color: #6d717a;\n        letter-spacing: 0;\n        line-height: 20px;\n      }\n    }\n  }\n\n  .additionalFlightDetails {\n    padding-top: 8px;\n    border-bottom: none;\n\n    .infoContainer {\n      max-width: 672px;\n      border: 1px solid #dddee0;\n      padding: 23px;\n      border-radius: 4px;\n    }\n\n    .Info {\n      display: flex;\n    }\n\n    .additionalInfoRow {\n      min-width: 270px;\n      font-size: 13px;\n      color: #6d717a;\n      letter-spacing: 0;\n      line-height: 20px;\n\n      span {\n        color: #1b2432;\n        letter-spacing: 0;\n      }\n    }\n  }\n\n  .checkins {\n    display: flex;\n\n    .checkin {\n      padding-right: 40px;\n    }\n  }\n\n  .roomType,\n  .checkins {\n    font-weight: 500;\n    font-size: 15px;\n    padding: 24px 0;\n    border-bottom: 1px solid #c6c8cc;\n\n    span {\n      color: #6d717a;\n      font-size: 13px;\n      line-height: 20px;\n      font-weight: 400;\n    }\n  }\n\n  .info {\n    display: flex;\n    padding: 24px 0 0;\n\n    .text {\n      padding: 0 24px 0 6px;\n      color: #6d717a;\n      font-size: 15px;\n    }\n  }\n}\n\n.boldText {\n  font-family: 'Roboto';\n  font-size: 17px;\n  color: #1b2432;\n  letter-spacing: 0;\n}\n\n.lightSubtitle {\n  font-family: 'Roboto';\n  font-size: 13px;\n  color: #6d717a;\n  letter-spacing: 0;\n}\n\n.editButton {\n  min-height: 32px;\n  width: 55px;\n  border-radius: 4px;\n  color: #4f84fa;\n  text-align: center;\n  align-self: center;\n  border: 1px solid #3189fb;\n  display: flex;\n  font-size: 15px;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  justify-self: right;\n}\n\n.linkText {\n  color: #1e8aff !important;\n  font-size: 13px;\n  cursor: pointer;\n  &:hover {\n    color: blue !important;\n    text-decoration: underline;\n  }\n}\n\n.tag {\n  background: rgba(255, 255, 255, 0);\n  border: 1px solid #1b2432;\n  border-radius: 4px;\n  font-size: 13px;\n  color: #1b2432;\n  letter-spacing: 0;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 32px;\n  width: fit-content;\n  padding-left: 6px;\n  padding-right: 6px;\n  margin-left: 7px;\n}\n\n.tagsContainer {\n  display: flex;\n  align-items: center;\n}\n\n.customFieldsList {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex: 1;\n}\n\n.customFieldRow {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  font-size: 13px;\n  color: #1b2432;\n}\n\n.customFieldName {\n  font-weight: 500;\n  color: #6d717a;\n  white-space: nowrap;\n  min-width: 120px;\n}\n\n.customFieldValue {\n  color: #1b2432;\n  word-break: break-word;\n}\n\n.customFieldEmpty {\n  font-size: 13px;\n  color: #9ea3ad;\n  font-style: italic;\n}\n\n.additionalBookingContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  div:first-child {\n    font-size: 13px;\n    color: #6d717a;\n    letter-spacing: 0;\n    line-height: 20px;\n    width: 100%;\n    overflow-wrap: break-word;\n  }\n\n  .textarea {\n    width: 100%;\n    font-family: 'Roboto', sans-serif;\n    font-size: 13px;\n    resize: none;\n    height: 100px;\n    line-height: 20px;\n    border: 1px solid #dddee0;\n    border-radius: 4px;\n    padding: 8px;\n    margin-bottom: 13px;\n  }\n\n  .noteText {\n    font-family: 'Roboto', sans-serif;\n    font-size: 13px;\n    width: 100%;\n    height: 100px;\n    overflow: scroll;\n    border: 1px solid #dddee0;\n    border-radius: 4px;\n    padding: 8px;\n    margin-top: 0px;\n  }\n}\n\n.additionalDetailsTitle {\n  font-size: 17px;\n  color: #1b2432;\n  letter-spacing: 0;\n  margin-top: 0;\n  margin-bottom: 14px;\n}\n\n.bookingAdditionalDetails {\n  margin-top: 32px;\n  margin-bottom: 32px;\n}\n\n.fraudSubtitle {\n  font-size: 13px;\n  color: #6d717a;\n  margin-bottom: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bookingDetails": `components-BookingDetails-styles___bookingDetails--RbsgY`,
	"widerNotes": `components-BookingDetails-styles___widerNotes--rfGA9`,
	"header": `components-BookingDetails-styles___header--nZl6V`,
	"title": `components-BookingDetails-styles___title--Is77J`,
	"tripAdvisor": `components-BookingDetails-styles___tripAdvisor--kZW0v`,
	"avatarAndName": `components-BookingDetails-styles___avatarAndName--ln44N`,
	"avatarContainer": `components-BookingDetails-styles___avatarContainer--Xz_fy`,
	"avatar": `components-BookingDetails-styles___avatar--CfylO`,
	"avatarLetter": `components-BookingDetails-styles___avatarLetter--Dc7iZ`,
	"headerInfoContainer": `components-BookingDetails-styles___headerInfoContainer--q6fEg`,
	"travelerInformationFlightTitle": `components-BookingDetails-styles___travelerInformationFlightTitle--wJpqm`,
	"travelerInformationFlightSubtitle": `components-BookingDetails-styles___travelerInformationFlightSubtitle--eybDb`,
	"travelerNumber": `components-BookingDetails-styles___travelerNumber--IhaYo`,
	"travelerInformationHotelTitle": `components-BookingDetails-styles___travelerInformationHotelTitle--oQq4a`,
	"travelerInformationHotelSubtitle": `components-BookingDetails-styles___travelerInformationHotelSubtitle--Aat9x`,
	"passengerInfo": `components-BookingDetails-styles___passengerInfo--yMs2E`,
	"passengerInfoRow": `components-BookingDetails-styles___passengerInfoRow--tZfrE`,
	"passengerHeader": `components-BookingDetails-styles___PassengerHeader--moKWG`,
	"travelerName": `components-BookingDetails-styles___travelerName--xg6xE`,
	"info": `components-BookingDetails-styles___Info--N994y`,
	"passportInfo": `components-BookingDetails-styles___passportInfo--0xkSK`,
	"passList": `components-BookingDetails-styles___passList--ZH0Sg`,
	"label": `components-BookingDetails-styles___label--pNQDp`,
	"additionalFlightDetails": `components-BookingDetails-styles___additionalFlightDetails--Mbbjo`,
	"infoContainer": `components-BookingDetails-styles___infoContainer--xn9tq`,
	"additionalInfoRow": `components-BookingDetails-styles___additionalInfoRow--jIz2j`,
	"checkins": `components-BookingDetails-styles___checkins--SzxUD`,
	"checkin": `components-BookingDetails-styles___checkin--KHlVG`,
	"roomType": `components-BookingDetails-styles___roomType--LQp7f`,
	"info": `components-BookingDetails-styles___info--vdYXv`,
	"text": `components-BookingDetails-styles___text--VIEPH`,
	"boldText": `components-BookingDetails-styles___boldText--oaTpP`,
	"lightSubtitle": `components-BookingDetails-styles___lightSubtitle--F67oL`,
	"editButton": `components-BookingDetails-styles___editButton--S_Ryu`,
	"linkText": `components-BookingDetails-styles___linkText--GEco_`,
	"tag": `components-BookingDetails-styles___tag--VRc7e`,
	"tagsContainer": `components-BookingDetails-styles___tagsContainer--OQuYM`,
	"customFieldsList": `components-BookingDetails-styles___customFieldsList--FDhiv`,
	"customFieldRow": `components-BookingDetails-styles___customFieldRow--T3KLC`,
	"customFieldName": `components-BookingDetails-styles___customFieldName--XN4ZO`,
	"customFieldValue": `components-BookingDetails-styles___customFieldValue--eSaww`,
	"customFieldEmpty": `components-BookingDetails-styles___customFieldEmpty--D7ftn`,
	"additionalBookingContainer": `components-BookingDetails-styles___additionalBookingContainer--yoN3v`,
	"textarea": `components-BookingDetails-styles___textarea--wMVdN`,
	"noteText": `components-BookingDetails-styles___noteText--ZZzIH`,
	"additionalDetailsTitle": `components-BookingDetails-styles___additionalDetailsTitle--nXVXq`,
	"bookingAdditionalDetails": `components-BookingDetails-styles___bookingAdditionalDetails--cRzy3`,
	"fraudSubtitle": `components-BookingDetails-styles___fraudSubtitle--_6xyS`
};
module.exports = ___CSS_LOADER_EXPORT___;
